<template>
  <div>
    <van-popup
      v-model="isShow"
      class="TrfilterPanel filter-panel"
      position="bottom"
      :lazy-render="false"
      :close-on-popstate="true"
      :style="{ maxHeight: '70%' }"
    >
      <ld-header
        border
        @click-left="isShow = false"
      >
        <span slot="left" />
        <span class="font14">{{ $t('C121','筛选') }}</span>
      </ld-header>
    
      <div
        class="train-filter-box pad16 van-hairline--bottom"
        v-for="(filter) in filters"
        :key="filter.row"
      >
        <p class="font12 gray">
          {{ filter.title }}
        </p>
        <van-checkbox-group
          class="train-filter-list font12"
          v-model="filter.result"
        >
          <van-checkbox
            v-for="(item, index) in filter.list"
            class="text-center"
            :key="index"
            :name="item"
          >
            {{ item }}
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <van-row class="filter-panel__reset">
        <a
          class="reset"
          @click="reset"
        >
          重置筛选
        </a>
        <a
          class="selection bg-main"
          @click="enter"
        >
          {{ $t('Display','显示结果') }}
        </a>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
import { Popup, CheckboxGroup, Checkbox } from 'vant'
import ldButton from 'Common/ldButton'

export default {
  name: 'TrFilterPanel',
  components: {
    [Popup.name]: Popup,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    ldButton
  },
  props: {
    visibility: {
      type: Boolean,
      default: false
    },
    toStationList: {
      type: Array,
      default: () => []
    },
    fromStationList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isShow: false,
      filters: [
        {
          row: 'startTime',
          title: '出发时间',
          result: [],
          list: ['00:00-06:00', '06:00-12:00', '12:00-18:00', '18:00-24:00'],
        },
        {
          row: 'arriveTime',
          title: '到达时间',
          result: [],
          list: ['00:00-06:00', '06:00-12:00', '12:00-18:00', '18:00-24:00'],
        },
        {
          row: 'trainType',
          title: '车次类型',
          result: [],
          list: ['高铁 (G/C)', '动车 (D)', '普通 (K/Z/T)'],
        }
      ]
    }
  },
  created () {
    this.isShow = this.visibility
    
    if (this.fromStationList.length > 1) {
      this.filters.push({
        row: 'fromStationName',
        title: '出发车站',
        result: [],
        list: this.fromStationList
      })
    }

    if (this.toStationList.length > 1) {
      this.filters.push({
        row: 'toStationName',
        title: '到达车站',
        result: [],
        list: this.toStationList
      })
    }
  },
  methods: {
    reset () {
      this.filters.forEach(filter => {
        filter.result = []
      })
      this.$emit('on-reset', [])
    },
    enter () {
      this.isShow = false
      
      let blankCount = 0
      this.filters.forEach(fliter => {
        if (fliter.result.length === 0) blankCount++
      })

      /**
       * 如果没有筛选则返回 '[]'
       */
      if (blankCount === this.filters.length) {
        this.$emit('on-enter', [])
      } else {
        this.$emit('on-enter', this.filters)
      }
    }
  },
  watch: {
    visibility(val) {
      this.isShow = val
    },
    isShow(val) {
      this.$emit('update:visibility', val)
    }
  }
}
</script>

<style lang="less">
.TrfilterPanel {
  border-radius: @border-radius-md @border-radius-md 0 0;
  padding-bottom: 52px;

  .pad16 {
    padding: 16px;
  }

  .train-filter-list {
    margin-top: 5px;

    .van-checkbox {
      width: 48%;
      display: inline-block;
      padding: 4px 0;
      background-color: #eef2f7;
      border: 1px solid #eef2f7;
      border-radius: @border-radius-sm;
      margin: 5px 1% 0;

      .van-checkbox__icon {
        display: none;
      }

      .van-checkbox__label {
        margin-left: 0;
      }

      /* active样式 */
      &[aria-checked=true] {
        background-color: @color-background-lightYellow;
        border: 1px solid;

        .van-checkbox__label {
          color: @color-text-main;
        }
      }
    }
  }

  .train-filter-footer {
    padding: 8px 16px;
    box-shadow: 0px -1px 3px 0px 
    rgba(42, 42, 42, 0.04);
    
    .ld-button {
      font-size: 12px;
      height: 34px;
      line-height: 34px;
    }
  }
}
</style>
